import { connect } from 'react-redux';
import NotaPromissoria from './notaPromissoria';

export default connect()(NotaPromissoria);
